import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const UpgradeModalContext = createContext({
  open: false,
  payload: null,
  openUpgradeModal: () => {},
  close: () => {},
});

export function UpgradeModalProvider({ children }) {
  const [state, setState] = useState({ open: false, payload: null });

  const openUpgradeModal = useCallback((payload = {}) => {
    setState({ open: true, payload });
  }, []);

  const close = useCallback(() => {
    setState({ open: false, payload: null });
  }, []);

  // Listen for global "billing:upgrade-needed" events fired from the axios
  // interceptor when the backend returns 403 with a feature/user-limit code.
  useEffect(() => {
    const onEvt = (e) => openUpgradeModal(e.detail || {});
    window.addEventListener("billing:upgrade-needed", onEvt);
    return () => window.removeEventListener("billing:upgrade-needed", onEvt);
  }, [openUpgradeModal]);

  const value = useMemo(
    () => ({ ...state, openUpgradeModal, close }),
    [state, openUpgradeModal, close]
  );

  return (
    <UpgradeModalContext.Provider value={value}>
      {children}
    </UpgradeModalContext.Provider>
  );
}

export const useUpgradeModal = () => useContext(UpgradeModalContext);
